export enum AppActionType {
    APP_ESSENTIAL_RELOAD = 'app/essential/reload'
}

export class AppActions {
    static triggerEssentialReload = () => ({ type: AppActionType.APP_ESSENTIAL_RELOAD });
}